import React, { Component } from 'react';
import usersService from '../../services/usersService';
import './UserManagement.css';

class UserManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            roles: [],
            companies: [],
            loading: true,
            error: null,
            showModal: false,
            showDetailsModal: false,
            showCompanyWarningModal: false,
            companyWarningAcknowledged: false,
            editingUser: null,
            selectedUser: null,
            sortColumn: 'lastName',
            sortDirection: 'asc',
            currentUser: null,
            formData: {
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                phone: '',
                notes: '',
                roleId: '',
                companyId: '',
                isActive: true
            },
            modalPosition: { x: 0, y: 0 },
            isDragging: false,
            dragOffset: { x: 0, y: 0 }
        };
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);
    }

    componentDidMount() {
        this.loadCurrentUser();
        this.loadData();
        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('mouseup', this.handleMouseUp);
    }

    componentWillUnmount() {
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.handleMouseUp);
    }

    loadCurrentUser() {
        try {
            var userStr = localStorage.getItem('user');
            if (userStr) {
                var user = JSON.parse(userStr);
                this.setState({ currentUser: user });
            }
        } catch (e) {
            console.error('Failed to load current user:', e);
        }
    }

    isSystemAdmin() {
        return this.state.currentUser && this.state.currentUser.role === 'System Administrator';
    }

    handleMouseDown(e) {
        var modal = document.getElementById('um-draggable-modal');
        if (modal) {
            var rect = modal.getBoundingClientRect();
            this.setState({
                isDragging: true,
                dragOffset: {
                    x: e.clientX - rect.left,
                    y: e.clientY - rect.top
                }
            });
        }
    }

    handleMouseMove(e) {
        if (this.state.isDragging) {
            this.setState({
                modalPosition: {
                    x: e.clientX - this.state.dragOffset.x,
                    y: e.clientY - this.state.dragOffset.y
                }
            });
        }
    }

    handleMouseUp() {
        this.setState({ isDragging: false });
    }

    async loadData() {
        try {
            var requests = [
                usersService.getAll(),
                usersService.getRoles()
            ];

            // Only System Admins need the companies list
            var userStr = localStorage.getItem('user');
            if (userStr) {
                var user = JSON.parse(userStr);
                if (user.role === 'System Administrator') {
                    requests.push(this.loadCompanies());
                }
            }

            var results = await Promise.all(requests);
            this.setState({ 
                users: results[0], 
                roles: results[1], 
                companies: results[2] || [],
                loading: false 
            });
        } catch (err) {
            this.setState({ error: err.message, loading: false });
        }
    }

    async loadCompanies() {
        var token = localStorage.getItem('token');
        var response = await fetch('/api/systemadmin/companies', {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        if (response.ok) {
            return await response.json();
        }
        return [];
    }

    handleSort(column) {
        var newDirection = 'asc';
        if (this.state.sortColumn === column && this.state.sortDirection === 'asc') {
            newDirection = 'desc';
        }
        this.setState({ sortColumn: column, sortDirection: newDirection });
    }

    getSortedUsers() {
        var users = this.state.users.slice();
        var column = this.state.sortColumn;
        var direction = this.state.sortDirection;

        users.sort(function(a, b) {
            var aVal, bVal;

            switch (column) {
                case 'name':
                    aVal = ((a.firstName || '') + ' ' + (a.lastName || '')).toLowerCase();
                    bVal = ((b.firstName || '') + ' ' + (b.lastName || '')).toLowerCase();
                    break;
                case 'email':
                    aVal = (a.email || '').toLowerCase();
                    bVal = (b.email || '').toLowerCase();
                    break;
                case 'companyDisplayName':
                    aVal = (a.companyDisplayName || '').toLowerCase();
                    bVal = (b.companyDisplayName || '').toLowerCase();
                    break;
                case 'roleName':
                    aVal = (a.roleName || '').toLowerCase();
                    bVal = (b.roleName || '').toLowerCase();
                    break;
                case 'isActive':
                    aVal = a.isActive ? 1 : 0;
                    bVal = b.isActive ? 1 : 0;
                    break;
                case 'createdAt':
                    aVal = new Date(a.createdAt).getTime();
                    bVal = new Date(b.createdAt).getTime();
                    break;
                default:
                    aVal = (a[column] || '').toString().toLowerCase();
                    bVal = (b[column] || '').toString().toLowerCase();
            }

            if (aVal < bVal) return direction === 'asc' ? -1 : 1;
            if (aVal > bVal) return direction === 'asc' ? 1 : -1;
            return 0;
        });

        return users;
    }

    getSortIndicator(column) {
        if (this.state.sortColumn !== column) return ' ↕';
        return this.state.sortDirection === 'asc' ? ' ▲' : ' ▼';
    }

    openAddModal() {
        var customerRole = this.state.roles.find(function(r) { return r.name === 'Customer'; });
        var currentUser = this.state.currentUser;
        
        this.setState({
            showModal: true,
            editingUser: null,
            companyWarningAcknowledged: false,
            modalPosition: { x: 0, y: 0 },
            formData: {
                email: '',
                password: '',
                firstName: '',
                lastName: '',
                phone: '',
                notes: '',
                roleId: customerRole ? customerRole.id : '',
                companyId: currentUser ? currentUser.companyId : '',
                isActive: true
            }
        });
    }

    openEditModal(user) {
        this.setState({
            showModal: true,
            showDetailsModal: false,
            editingUser: user,
            companyWarningAcknowledged: false,
            modalPosition: { x: 0, y: 0 },
            formData: {
                email: user.email,
                password: '',
                firstName: user.firstName || '',
                lastName: user.lastName || '',
                phone: user.phone || '',
                notes: user.notes || '',
                roleId: user.roleId || '',
                companyId: user.companyId || '',
                isActive: user.isActive
            }
        });
    }

    openDetailsModal(user) {
        this.setState({
            showDetailsModal: true,
            selectedUser: user,
            modalPosition: { x: 0, y: 0 }
        });
    }

    closeModal() {
        this.setState({ showModal: false, editingUser: null, companyWarningAcknowledged: false });
    }

    closeDetailsModal() {
        this.setState({ showDetailsModal: false, selectedUser: null });
    }

    handleChange(field, value) {
        var newFormData = Object.assign({}, this.state.formData);
        newFormData[field] = value;
        this.setState({ formData: newFormData });
    }

    handleCompanyFieldClick() {
        if (!this.state.companyWarningAcknowledged) {
            this.setState({ showCompanyWarningModal: true });
        }
    }

    handleCompanyChange(value) {
        if (this.state.companyWarningAcknowledged) {
            this.handleChange('companyId', value);
        }
    }

    acknowledgeCompanyWarning() {
        this.setState({ 
            showCompanyWarningModal: false, 
            companyWarningAcknowledged: true 
        });
    }

    cancelCompanyWarning() {
        this.setState({ showCompanyWarningModal: false });
    }

    async handleSubmit(e) {
        e.preventDefault();
        var editingUser = this.state.editingUser;
        var formData = this.state.formData;

        // Build the request data
        var requestData = {
            email: formData.email,
            password: formData.password,
            firstName: formData.firstName,
            lastName: formData.lastName,
            phone: formData.phone,
            notes: formData.notes,
            roleId: formData.roleId ? parseInt(formData.roleId) : null,
            isActive: formData.isActive
        };

        // Only include companyId if System Admin
        if (this.isSystemAdmin() && formData.companyId) {
            requestData.companyId = parseInt(formData.companyId);
        }

        try {
            if (editingUser) {
                await usersService.update(editingUser.id, requestData);
            } else {
                await usersService.create(requestData);
            }
            this.closeModal();
            this.loadData();
        } catch (err) {
            alert(err.message);
        }
    }

    async handleDelete(user) {
        if (!window.confirm('Are you sure you want to delete ' + user.firstName + ' ' + user.lastName + '?')) {
            return;
        }

        try {
            await usersService.delete(user.id);
            this.loadData();
        } catch (err) {
            alert('Failed to delete user: ' + err.message);
        }
    }

    async toggleActive(user) {
        try {
            await usersService.update(user.id, { isActive: !user.isActive });
            this.loadData();
        } catch (err) {
            alert('Failed to update user: ' + err.message);
        }
    }

    async saveNotes(userId, notes) {
        try {
            await usersService.update(userId, { notes: notes });
            this.loadData();
            var updatedUser = Object.assign({}, this.state.selectedUser, { notes: notes });
            this.setState({ selectedUser: updatedUser });
        } catch (err) {
            alert('Failed to save notes: ' + err.message);
        }
    }

    formatDate(dateString) {
        return new Date(dateString).toLocaleDateString();
    }

    getCompanyName(user) {
        return user.companyDisplayName || user.companyName || '-';
    }

    getCompanyNameById(companyId) {
        var company = this.state.companies.find(function(c) { return c.id === parseInt(companyId); });
        return company ? company.name : 'Select Company';
    }

    render() {
        var state = this.state;
        var self = this;

        if (state.loading) {
            return <div className="user-management"><p>Loading...</p></div>;
        }

        if (state.error) {
            return <div className="user-management"><p className="error">Error: {state.error}</p></div>;
        }

        var modalStyle = {};
        if (state.modalPosition.x !== 0 || state.modalPosition.y !== 0) {
            modalStyle = {
                position: 'fixed',
                left: state.modalPosition.x + 'px',
                top: state.modalPosition.y + 'px',
                margin: 0
            };
        }

        var sortedUsers = this.getSortedUsers();
        var isSystemAdmin = this.isSystemAdmin();

        return (
            <div className="user-management">
                <div className="um-header">
                    <h2>User Management</h2>
                    <button onClick={function() { self.openAddModal(); }} className="btn-add">
                        + Add User
                    </button>
                </div>

                <div className="um-count">{state.users.length} User(s)</div>

                <table className="um-table">
                    <thead>
                        <tr>
                            <th className="sortable" onClick={function() { self.handleSort('name'); }}>
                                Name{self.getSortIndicator('name')}
                            </th>
                            <th className="sortable" onClick={function() { self.handleSort('email'); }}>
                                Email{self.getSortIndicator('email')}
                            </th>
                            <th className="sortable" onClick={function() { self.handleSort('companyDisplayName'); }}>
                                Company{self.getSortIndicator('companyDisplayName')}
                            </th>
                            <th className="sortable" onClick={function() { self.handleSort('roleName'); }}>
                                Role{self.getSortIndicator('roleName')}
                            </th>
                            <th className="sortable" onClick={function() { self.handleSort('isActive'); }}>
                                Status{self.getSortIndicator('isActive')}
                            </th>
                            <th className="sortable" onClick={function() { self.handleSort('createdAt'); }}>
                                Created{self.getSortIndicator('createdAt')}
                            </th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedUsers.map(function(user) {
                            return (
                                <tr key={user.id}>
                                    <td>
                                        <span 
                                            className="user-name-link"
                                            onClick={function() { self.openDetailsModal(user); }}
                                        >
                                            {user.firstName} {user.lastName}
                                        </span>
                                    </td>
                                    <td>{user.email}</td>
                                    <td>{self.getCompanyName(user)}</td>
                                    <td>{user.roleName}</td>
                                    <td>
                                        <span 
                                            className={'status-badge ' + (user.isActive ? 'active' : 'inactive')}
                                            onClick={function() { self.toggleActive(user); }}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {user.isActive ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td>{self.formatDate(user.createdAt)}</td>
                                    <td>
                                        <button 
                                            onClick={function() { self.openEditModal(user); }}
                                            className="btn-edit"
                                        >
                                            Edit
                                        </button>
                                        <button 
                                            onClick={function() { self.handleDelete(user); }}
                                            className="btn-delete"
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                {/* User Details Modal */}
                {state.showDetailsModal && state.selectedUser && (
                    <div className="um-modal-overlay">
                        <div 
                            id="um-draggable-modal"
                            className="um-modal um-details-modal" 
                            style={modalStyle}
                        >
                            <div 
                                className="um-modal-header"
                                onMouseDown={this.handleMouseDown}
                            >
                                <h3>User Details</h3>
                                <button className="um-modal-close" onClick={function() { self.closeDetailsModal(); }}>&times;</button>
                            </div>
                            <div className="um-modal-body">
                                <div className="user-details-grid">
                                    <div className="detail-row">
                                        <span className="detail-label">Name:</span>
                                        <span className="detail-value">{state.selectedUser.firstName} {state.selectedUser.lastName}</span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Email:</span>
                                        <span className="detail-value">{state.selectedUser.email}</span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Company:</span>
                                        <span className="detail-value">{self.getCompanyName(state.selectedUser)}</span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Phone:</span>
                                        <span className="detail-value">{state.selectedUser.phone || '-'}</span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Role:</span>
                                        <span className="detail-value">{state.selectedUser.roleName}</span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Status:</span>
                                        <span className={'detail-value status-badge ' + (state.selectedUser.isActive ? 'active' : 'inactive')}>
                                            {state.selectedUser.isActive ? 'Active' : 'Inactive'}
                                        </span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Created:</span>
                                        <span className="detail-value">{self.formatDate(state.selectedUser.createdAt)}</span>
                                    </div>
                                </div>
                                <div className="notes-section">
                                    <label>Notes:</label>
                                    <textarea
                                        value={state.selectedUser.notes || ''}
                                        onChange={function(e) {
                                            var updatedUser = Object.assign({}, state.selectedUser, { notes: e.target.value });
                                            self.setState({ selectedUser: updatedUser });
                                        }}
                                        placeholder="Add notes about this user..."
                                        rows="4"
                                    />
                                    <button 
                                        className="btn-save-notes"
                                        onClick={function() { self.saveNotes(state.selectedUser.id, state.selectedUser.notes); }}
                                    >
                                        Save Notes
                                    </button>
                                </div>
                            </div>
                            <div className="um-modal-footer">
                                <button 
                                    className="btn-edit"
                                    onClick={function() { self.openEditModal(state.selectedUser); }}
                                >
                                    Edit User
                                </button>
                                <button className="btn-cancel" onClick={function() { self.closeDetailsModal(); }}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Edit/Add User Modal */}
                {state.showModal && (
                    <div className="um-modal-overlay">
                        <div 
                            id="um-draggable-modal"
                            className="um-modal" 
                            style={modalStyle}
                        >
                            <div 
                                className="um-modal-header"
                                onMouseDown={this.handleMouseDown}
                            >
                                <h3>{state.editingUser ? 'Edit User' : 'Add User'}</h3>
                                <button className="um-modal-close" onClick={function() { self.closeModal(); }}>&times;</button>
                            </div>
                            <form onSubmit={function(e) { self.handleSubmit(e); }}>
                                <div className="um-modal-body">
                                    <div className="um-form-row">
                                        <div className="um-form-group">
                                            <label>First Name</label>
                                            <input
                                                type="text"
                                                value={state.formData.firstName}
                                                onChange={function(e) { self.handleChange('firstName', e.target.value); }}
                                            />
                                        </div>
                                        <div className="um-form-group">
                                            <label>Last Name</label>
                                            <input
                                                type="text"
                                                value={state.formData.lastName}
                                                onChange={function(e) { self.handleChange('lastName', e.target.value); }}
                                            />
                                        </div>
                                    </div>

                                    <div className="um-form-group">
                                        <label>Email *</label>
                                        <input
                                            type="email"
                                            value={state.formData.email}
                                            onChange={function(e) { self.handleChange('email', e.target.value); }}
                                            required
                                        />
                                    </div>

                                    <div className="um-form-group">
                                        <label>{state.editingUser ? 'New Password (leave blank to keep current)' : 'Password *'}</label>
                                        <input
                                            type="password"
                                            value={state.formData.password}
                                            onChange={function(e) { self.handleChange('password', e.target.value); }}
                                            required={!state.editingUser}
                                        />
                                    </div>

                                    {/* Company field - only for System Admins */}
                                    {isSystemAdmin && (
                                        <div className="um-form-group">
                                            <label>Company *</label>
                                            {!state.companyWarningAcknowledged ? (
                                                <div 
                                                    className="company-select-locked"
                                                    onClick={function() { self.handleCompanyFieldClick(); }}
                                                >
                                                    <span className="locked-value">
                                                        {state.formData.companyId ? self.getCompanyNameById(state.formData.companyId) : 'Select Company'}
                                                    </span>
                                                    <span className="lock-icon">🔒</span>
                                                </div>
                                            ) : (
                                                <select
                                                    value={state.formData.companyId}
                                                    onChange={function(e) { self.handleCompanyChange(e.target.value); }}
                                                    required
                                                >
                                                    <option value="">Select Company</option>
                                                    {state.companies.map(function(company) {
                                                        return <option key={company.id} value={company.id}>{company.name}</option>;
                                                    })}
                                                </select>
                                            )}
                                            {!state.companyWarningAcknowledged && (
                                                <small className="field-hint">🔒 Click to unlock and modify company assignment</small>
                                            )}
                                        </div>
                                    )}

                                    <div className="um-form-row">
                                        <div className="um-form-group">
                                            <label>Phone</label>
                                            <input
                                                type="text"
                                                value={state.formData.phone}
                                                onChange={function(e) { self.handleChange('phone', e.target.value); }}
                                            />
                                        </div>
                                        <div className="um-form-group">
                                            <label>Role</label>
                                            <select
                                                value={state.formData.roleId}
                                                onChange={function(e) { self.handleChange('roleId', e.target.value); }}
                                            >
                                                <option value="">Select Role</option>
                                                {state.roles.map(function(role) {
                                                    return <option key={role.id} value={role.id}>{role.name}</option>;
                                                })}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="um-form-group">
                                        <label>Notes</label>
                                        <textarea
                                            value={state.formData.notes}
                                            onChange={function(e) { self.handleChange('notes', e.target.value); }}
                                            placeholder="Add notes about this user..."
                                            rows="3"
                                        />
                                    </div>

                                    {state.editingUser && (
                                        <div className="um-form-group">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    checked={state.formData.isActive}
                                                    onChange={function(e) { self.handleChange('isActive', e.target.checked); }}
                                                />
                                                {' '}Active
                                            </label>
                                        </div>
                                    )}
                                </div>
                                <div className="um-modal-footer">
                                    <button type="button" className="btn-cancel" onClick={function() { self.closeModal(); }}>
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn-save">
                                        {state.editingUser ? 'Save Changes' : 'Create User'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {/* Company Assignment Warning Modal - rendered with portal-like high z-index */}
                {state.showCompanyWarningModal && (
                    <div className="um-warning-overlay">
                        <div className="um-modal um-warning-modal">
                            <div className="um-modal-header um-warning-header">
                                <h3>⚠️ Data Security Warning</h3>
                            </div>
                            <div className="um-modal-body">
                                <div className="warning-content">
                                    <p><strong>You are about to modify company assignment.</strong></p>
                                    <p>
                                        Assigning a user to the wrong company will grant them access to that company's 
                                        confidential data, including:
                                    </p>
                                    <ul>
                                        <li>Customer information and contacts</li>
                                        <li>Quotes and pricing data</li>
                                        <li>Product configurations</li>
                                        <li>Internal notes and communications</li>
                                    </ul>
                                    <p className="warning-emphasis">
                                        Incorrect company assignments may result in data breaches and potential legal liability.
                                    </p>
                                    <p>
                                        Please verify the company selection carefully before saving.
                                    </p>
                                </div>
                            </div>
                            <div className="um-modal-footer">
                                <button 
                                    type="button" 
                                    className="btn-cancel" 
                                    onClick={function() { self.cancelCompanyWarning(); }}
                                >
                                    Cancel
                                </button>
                                <button 
                                    type="button" 
                                    className="btn-warning-acknowledge" 
                                    onClick={function() { self.acknowledgeCompanyWarning(); }}
                                >
                                    I Understand, Proceed
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default UserManagement;